export default __webpack_public_path__ + "static/media/olympiads.85f402ff.svg";